import { defaultConfig } from './constants';

const defaultState = defaultConfig;

const reducer = (state = defaultState) => state;

export default reducer;
